import React, { FC } from "react";
import FadeIn from "react-fade-in";
import { FiActivity } from "react-icons/fi";
import Table from "../../../atom/table";

interface TranscriptionProcessingProps {
  startDate: string;
  endDate: string;
  refreshTrigger?: number;
}

const TranscriptionProcessing: FC<TranscriptionProcessingProps> = ({
  startDate,
  endDate,
  refreshTrigger,
}) => {
  // Mock data for the table
  const processingData = [
    { id: "af9731fa-5430-43d3-8e5a-287f84ec6f38", created_at: "Jun 1, 10:39:34", duration: "121.0s", stt_time: "1s", status: "COMPLETED" },
    { id: "5f6014a1-90f4-4867-a42f-2db0fdd094f0", created_at: "Jun 1, 10:39:24", duration: "126.9s", stt_time: "2s", status: "COMPLETED" },
    { id: "a1566831-f238-4813-b3dc-79490b9e5f61", created_at: "Jun 1, 10:32:22", duration: "29.7s", stt_time: "1s", status: "COMPLETED" },
    { id: "b78c53ed-da5c-43ed-927f-aaf675c5897d", created_at: "Jun 1, 10:23:35", duration: "299.5s", stt_time: "4s", status: "COMPLETED" },
    { id: "151fe8b5-5f74-430d-bfea-21afa3e0097b", created_at: "Jun 1, 10:16:23", duration: "16.9s", stt_time: "1s", status: "COMPLETED" },
    { id: "3334dca8-2c4f-41ee-8d9f-5bba075a59a4", created_at: "Jun 1, 10:15:23", duration: "30.7s", stt_time: "1s", status: "COMPLETED" },
    { id: "0aaa1931-06f4-4408-aedf-5c8996cc6097", created_at: "Jun 1, 10:13:23", duration: "8.7s", stt_time: "0s", status: "COMPLETED" },
    { id: "e39deac8-18bf-4f48-8ef0-4d15aa0ac5f3", created_at: "Jun 1, 10:03:22", duration: "6.0s", stt_time: "0s", status: "COMPLETED" },
    { id: "1aead8b8-29d7-4e75-b7df-7a334f6660a0", created_at: "Jun 1, 09:55:34", duration: "167.0s", stt_time: "3s", status: "COMPLETED" },
    { id: "376d9dd7-d637-46ec-9684-47598840576a", created_at: "Jun 1, 09:52:24", duration: "220.4s", stt_time: "3s", status: "COMPLETED" },
    { id: "c87f5f48-59e5-4ccd-9423-1e04c2fcbf87", created_at: "Jun 1, 09:48:23", duration: "18.0s", stt_time: "1s", status: "COMPLETED" },
    { id: "89f2ffd9-1f24-4d48-b1e5-ab59e1651085", created_at: "Jun 1, 09:48:22", duration: "18.9s", stt_time: "1s", status: "COMPLETED" },
    { id: "aba100c3-be8f-4f9c-bba4-b35d48afcd0f", created_at: "Jun 1, 09:47:23", duration: "17.0s", stt_time: "1s", status: "COMPLETED" },
    { id: "7b6a984a-9503-4d55-bc10-327cd4c7f99d", created_at: "Jun 1, 09:45:22", duration: "14.2s", stt_time: "1s", status: "COMPLETED" },
  ];

  const tableTitles = [
    { title: "Created At", key: "created_at", class: "w-[20%]" },
    { title: "Job Id", key: "id", class: "w-[40%]" },
    { title: "Duration", key: "duration", class: "w-[15%]" },
    { title: "Stt Time", key: "stt_time", class: "w-[10%]" },
    { title: "Status", key: "status", class: "w-[15%]" },
  ];

  const formattedData = processingData.map(row => ({
    ...row,
    id: row.id,
    duration: <span className="text-gray-800">{row.duration}</span>,
    status: (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border bg-green-50 text-green-600 border-green-200">
        <span className="font-bold">✓</span>
        Completed
      </span>
    ),
  }));

  return (
    <div className="flex flex-col gap-8 w-full">
      {/* Total Records Card */}
      <FadeIn>
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 flex items-center gap-6 w-full lg:max-w-md">
            <div className="p-4 bg-blue-50 text-blue-500 rounded-2xl shadow-inner">
                <FiActivity size={28} />
            </div>
            <div>
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Total Records</p>
                <h3 className="text-4xl font-extrabold text-slate-800">304</h3>
            </div>
        </div>
      </FadeIn>

      {/* Table Section */}
      <FadeIn delay={100}>
        <div className="bg-white rounded-[20px] shadow-sm border border-gray-100 overflow-hidden">
            <Table 
                tableTitles={tableTitles}
                tableData={formattedData}
                width="w-full"
                scrollHeight="h-[calc(100vh-450px)]"
                rowColorClass="bg-white"
            />
        </div>
      </FadeIn>
    </div>
  );
};

export default TranscriptionProcessing;
